import { render, staticRenderFns } from "./NotesAndFiles.vue?vue&type=template&id=44170bac"
import script from "./NotesAndFiles.vue?vue&type=script&lang=js"
export * from "./NotesAndFiles.vue?vue&type=script&lang=js"
import style0 from "./NotesAndFiles.vue?vue&type=style&index=0&id=44170bac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports